import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import School from "../screens/school";
import SchoolFullDetails from "../screens/SchoolFullDetails";
import AnalyticsDashboard from "../screens/AnalyticsDashboard";

// Analytics Detail Screens
import InfrastructureAnalysis from "../screens/analytics/InfrastructureAnalysis";
import EnrollmentAnalysis from "../screens/analytics/EnrollmentAnalysis";
import ICTProfileAnalysis from "../screens/analytics/ICTProfileAnalysis";
import LibraryProfileAnalysis from "../screens/analytics/LibraryProfileAnalysis";
import NCCProfileAnalysis from "../screens/analytics/NCCProfileAnalysis";
import CWSNProfileAnalysis from "../screens/analytics/CWSNProfileAnalysis";
import SportsInfrastructureAnalysis from "../screens/analytics/SportsInfrastructureAnalysis";
import GreenBuildingAnalysis from "../screens/analytics/GreenBuildingAnalysis";
import SafetyAnalysis from "../screens/analytics/SafetyAnalysis";
import SpecialLabsAnalysis from "../screens/analytics/SpecialLabsAnalysis";
import WaterProfileAnalysis from "../screens/analytics/WaterProfileAnalysis";
import StudentHolisticRoutes from "../../student-holistic/routes";

const KvsSamagamRoutes: React.FC = () => (
  <Routes>
    <Route index element={<Navigate to="schools" replace />} />
    <Route path="schools" element={<School />} />
    <Route path="school/:schoolID" element={<SchoolFullDetails />} />
    <Route path="analytics" element={<AnalyticsDashboard />} />

    {/* Analytics Detail Routes */}
    <Route path="analytics/infrastructure" element={<InfrastructureAnalysis />} />
    <Route path="analytics/enrollment" element={<EnrollmentAnalysis />} />
    <Route path="analytics/ict-profile" element={<ICTProfileAnalysis />} />
    <Route path="analytics/library-profile" element={<LibraryProfileAnalysis />} />
    <Route path="analytics/ncc-profile" element={<NCCProfileAnalysis />} />
    <Route path="analytics/cwsn-profile" element={<CWSNProfileAnalysis />} />
    <Route path="analytics/sports" element={<SportsInfrastructureAnalysis />} />
    <Route path="analytics/green-building" element={<GreenBuildingAnalysis />} />
    <Route path="analytics/safety" element={<SafetyAnalysis />} />
    <Route path="analytics/special-labs" element={<SpecialLabsAnalysis />} />
    <Route path="analytics/miscellaneous" element={<WaterProfileAnalysis />} />

    {/* Student Holistic Development Analytics */}
    <Route path="student-analytics/*" element={<StudentHolisticRoutes />} />
  </Routes>
);

export default KvsSamagamRoutes;
